import { SpinLoading } from 'antd-mobile'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { FC } from 'react'
import styles from './AmeSpin.module.less'
import { commonUtils } from '@/helpers/commonUtils'
import { ConfigProvider, Spin } from 'antd'

interface AmeSpinProps {
  className?: string
  fullscreen?: boolean
}

const AmeSpin: FC<AmeSpinProps> = observer((props: AmeSpinProps) => {
  const { fullscreen, className } = props
  if (!commonUtils.isMobile()) {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#FF7006',
            colorPrimaryHover: '#FF6D00',
          },
        }}
      >
        <Spin />
      </ConfigProvider>
    )
  }
  return (
    <SpinLoading
      className={classNames(styles.ameSpin, className, {
        [styles.fullscreen]: fullscreen,
      })}
    />
  )
})

export default AmeSpin
